import { Tile, TileStripe } from "@dash/tile";
import { useTheme } from "@emotion/react";
import { MdCheckCircle, MdPauseCircle, MdWarningAmber } from "react-icons/md";

import { Order } from "@megaron/fulfillment-contracts";
import { OrderDisplayFulfillmentStatus } from "@megaron/shopify";

type Props = {
  order: Order;
};

export const OrderPackingStatusBanners = ({ order }: Props) => {
  const theme = useTheme();

  if (order.cancelledAt != null) {
    return (
      <Tile gap="8px" stripe={<TileStripe color={theme.colors.danger} />}>
          <div
            css={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              css={{
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
                fontSize: "1rem",
                fontWeight: 700,
                color: theme.colors.danger,
              }}
            >
              <MdWarningAmber size={20} />
              Zamówienie anulowane
            </div>
          </div>
        </Tile>
    );
  }

  if (order.fulfillmentStatus === OrderDisplayFulfillmentStatus.Fulfilled) {
    return (
      <Tile gap="8px" stripe={<TileStripe color={theme.colors.success} />}>
          <div
            css={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              css={{
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
                fontSize: "1rem",
                fontWeight: 700,
                color: theme.colors.success,
              }}
            >
              <MdCheckCircle size={20} />
              Zamówienie zrealizowane
            </div>
          </div>
        </Tile>
    );
  }

  if (order.fulfillmentStatus === OrderDisplayFulfillmentStatus.OnHold) {
    return (
      <Tile gap="4px" stripe={<TileStripe color={theme.colors.warning} />}>
          <div
            css={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "4px",
            }}
          >
            <div
              css={{
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
                fontSize: "1rem",
                fontWeight: 700,
                color: theme.colors.warning,
              }}
            >
              <MdPauseCircle size={20} />
              Zamówienie wstrzymane
            </div>
            <div css={{ fontSize: "0.875rem", color: theme.colors.secondaryText }}>
              W Shopify zamówienie jest wstrzymane. Pakowanie i edycja paczek są wyłączone.
            </div>
          </div>
        </Tile>
    );
  }

  return null;
};
